import React, { memo, useCallback, useEffect, useRef } from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
`;

const GroupTitleInput = styled.textarea`
  resize: none;
  max-height: 88px;
  width: 100%;
  padding: 8px 15px;
  font-size: 16px;
  line-height: 24px;
  color: #1e1e1e;

  ::-webkit-scrollbar {
    width: 3px;
  }
`;

const GroupDescriptionInput = styled(GroupTitleInput)``;

const GroupTitleAndDescription = () => {
  const groupTitleInputRef = useRef(null);
  const groupDescriptionInputRef = useRef(null);

  const handleGroupTitleInput = useCallback((event) => {
    () => {};
  }, []);

  //! добавить стейт в массив
  useEffect(() => {
    if (groupTitleInputRef.current) {
      groupTitleInputRef.current.style.height = "auto";
      groupTitleInputRef.current.style.height =
        groupTitleInputRef.current.scrollHeight + "px";
    }
  }, [groupTitleInputRef]);

  const handleGroupDescriptionInput = useCallback((event) => {
    () => {};
  }, []);

  //! добавить стейт в массив
  useEffect(() => {
    if (groupDescriptionInputRef.current) {
      groupDescriptionInputRef.current.style.height = "auto";
      groupDescriptionInputRef.current.style.height =
        groupDescriptionInputRef.current.scrollHeight + "px";
    }
  }, [groupDescriptionInputRef]);

  return (
    <>
      <InputWrapper>
        <GroupTitleInput
          ref={groupTitleInputRef}
          placeholder="Название"
          type="text"
          rows={1}
          value={""}
          onChange={handleGroupTitleInput}
        />
      </InputWrapper>

      <InputWrapper>
        <GroupDescriptionInput
          ref={groupDescriptionInputRef}
          placeholder="Описание"
          type="text"
          rows={1}
          value={""}
          onChange={handleGroupDescriptionInput}
        />
      </InputWrapper>
    </>
  );
};

export default memo(GroupTitleAndDescription);
